module.exports = __webpack_public_path__ + "img/place-24px.d92fef19.svg";